import { OtherDebtSummarySumTable } from '../../../TtDetails';
import { useTotalTermElementDetailViewSummaryPage } from './hooks';
import { TotalTermElementDetailViewOtherDebtPageProps } from './types';
import { SummaryPageContainer } from './components';

export function TotalTermElementDetailViewOtherDebtPage({
  householdID,
  onClickItem,
}: TotalTermElementDetailViewOtherDebtPageProps) {
  const { tPages } = useTotalTermElementDetailViewSummaryPage();

  return (
    <SummaryPageContainer
      heading={tPages('total-term-element-detail-view-other-debt-summary-page-heading')}
      emptyDescription={tPages('total-term-element-detail-view-other-debt-summary-page-empty-description')}
    >
      <OtherDebtSummarySumTable hideOnEmpty className="mt-10" householdID={householdID} onClickItem={onClickItem} />
    </SummaryPageContainer>
  );
}
